import { Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";

const ButtonToolbar = ({
  title,
  navigateURL,
  onExport,
  onPrint,
  exportMode = false,
}) => {
 
  
  const [isExporting, setIsExporting] = useState(false);
  const [isPrinting, setIsPrinting] = useState(false);

  const handleExport = async (type = "pdf") => {
    setIsExporting(true);
    try {
      onExport && (await onExport(type));
    } catch (error) {
      console.error("Export error:", error);
    } finally {
      setTimeout(() => setIsExporting(false), 2000);
    }
  };

  const handlePrint = async (type = "pdf") => {
    setIsPrinting(true);
    try {
      onPrint && (await onPrint(type));
    } catch (error) {
      console.error("Print error:", error);
    } finally {
      setTimeout(() => setIsPrinting(false), 2000);
    }
  };

  return (
    <div className="py-2 flex items-center gap-3">
      <Link to={navigateURL}>
        <Button variant="contained">{title}</Button>
      </Link>
      {exportMode && (
        <Button
          onClick={() => handleExport("csv")}
          disabled={isExporting}
          startIcon={isExporting && <CircularProgress size={14} />}
        >
          {isExporting ? "Exporting..." : "Export"}
        </Button>
      )}
      {exportMode && (
        <Button
          onClick={() => handlePrint("pdf")}
          disabled={isPrinting}
          startIcon={isPrinting && <CircularProgress size={14} />}
        >
          {isPrinting ? "Printing..." : "Print"}
        </Button>
      )}
    </div>
  );
};

export default ButtonToolbar;
